import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },

  tableContainer: {
    borderRadius: '8px',
    overflow: 'hidden',
  },
  tableHeader: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#E4E6E8',
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(224, 224, 224, 1)'}`,
  },
  tableRow: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#f4f6f8',
    width: '100%',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
    },
  },
  tableCell: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(224, 224, 224, 0.5)'}`,
  },
  tituloTabela: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  textoTituloTabela: {
    fontSize: '18px',
  },
  // Mobile Styles
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  mobileCard: {
    padding: theme.spacing(2.5),
    borderRadius: '12px',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(10, 37, 64, 0.08)'}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.015)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(10, 37, 64, 0.15)',
      transform: 'translateY(-1px)',
    },
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'}`,
    paddingBottom: theme.spacing(1),
  },
  mobileActionTitle: {
    fontWeight: 700,
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
    letterSpacing: '0.5px',
  },
  mobileDetailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  mobileDetailItem: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& span': {
      color: theme.palette.text.primary,
      fontWeight: 500,
      textAlign: 'right',
    },
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4, 2),
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
